import oral_oncology_icon from '../../assets/track_icons/Oral_Oncology.png';
import ai_oral_diagnostics_icon from "../../assets/track_icons/AI_in_Oral_ Diagnostics.png";
import dental_pharmacology_icon from '../../assets/track_icons/Dental_Pharmacology.png';
import oral_cancer_icon from "../../assets/track_icons/Oral_Cancer.png";
import forensic_dentistry_icon from "../../assets/track_icons/Forensic_Dentistry.png";
import imaging_3d_icon from "../../assets/track_icons/3d_imaging.jpg";
import dental_stem_cells_icon from "../../assets/track_icons/Dental_Stem_Cells.png";
import periodontics_icon from "../../assets/track_icons/Periodontics.png";
import oral_pathophysiology_icon from "../../assets/track_icons/Oral_Pathophysiology.png";
import pain_management_icon from "../../assets/track_icons/Pain_Management.png";
import cosmetic_dentistry_icon from "../../assets/track_icons/Cosmetic_Dentistry.jpg";
import gerontology_icon from "../../assets/track_icons/Gerontology.png";
import oral_implantology_icon from '../../assets/track_icons/Oral_Implantology.png';
import orthodontics_icon from '../../assets/track_icons/Orthodontics.png';
import maxillofacial_surgery_icon from '../../assets/track_icons/maxillofacial_surgery.png';
import sleep_dentistry_icon from '../../assets/track_icons/Sleep_Dentistry.png';
import geriatric_dentistry_icon from '../../assets/track_icons/Geriatric_Dentistry.png';
import pediatric_dentistry_icon from '../../assets/track_icons/Pediatric_Dentistry.png';
import endodontics_icon from '../../assets/track_icons/Endodontics.png';
import laser_dentistry_icon from '../../assets/track_icons/Laser_Dentistry.png';

export const tracks = [
  { name: "AI in Oral Diagnostics", icon: ai_oral_diagnostics_icon },
  { name: "Oral Implantology", icon: oral_implantology_icon },
  { name: "Dental Pharmacology", icon: dental_pharmacology_icon },
  { name: "Oral Cancer", icon: oral_cancer_icon },
  { name: "Orthodontics", icon: orthodontics_icon },
  { name: "Forensic Dentistry", icon: forensic_dentistry_icon },
  { name: "3D Imaging", icon: imaging_3d_icon },
  { name: "Maxillofacial Surgery", icon: maxillofacial_surgery_icon },
  { name: "Sleep Dentistry", icon: sleep_dentistry_icon },
  { name: "Periodontics", icon: periodontics_icon },
  { name: "Oral Pathophysiology", icon: oral_pathophysiology_icon },
  { name: "Geriatric Dentistry", icon: geriatric_dentistry_icon },
  { name: "Pain Management", icon: pain_management_icon },
  { name: "Oral Oncology", icon: oral_oncology_icon },
  { name: "Pediatric Dentistry", icon: pediatric_dentistry_icon },
  { name: "Endodontics", icon: endodontics_icon },
  { name: "Laser Dentistry", icon: laser_dentistry_icon },
  { name: "Cosmetic Dentistry", icon: cosmetic_dentistry_icon },
  { name: "Digital Dental Education", icon: gerontology_icon },
  { name: "Dental Stem Cells", icon: dental_stem_cells_icon },
];
